import logger from '../log';
import { dispatchPlayerEvent } from '../events/dispatch';
import { NonStdPlayerEvents } from '../common/Reporter/constants';

const log = logger.getLogger(__filename);

interface MediaAttributesObject {
  attributes?: { BANDWIDTH?: number };
}

interface VideoPlaylist {
  media: () => MediaAttributesObject;
}

export interface VideoHS {
  playlists?: VideoPlaylist;
}

export type VoidMethod = () => void;
export interface Player {
  on: (s: string, p: VoidMethod) => void;
}
export interface VideoJsTech {
  vhs?: VideoHS;
  hls?: VideoHS;
}

export const getBandwidth = (vhs: VideoHS): number | undefined => {
  if (!vhs || !vhs.playlists || !vhs.playlists.media) {
    return;
  }
  const media = vhs.playlists.media();
  return media && media.attributes && media.attributes.BANDWIDTH;
};

const addHlsBitrateTracker = (player: Player, tech: VideoJsTech): void => {
  // SRV-1439
  // We need to get the bitrate which there is no event for. Use the
  // 'timeupdate' event to track when bitrate changes.
  // NOTE: this information is only available when we have the
  // metadata available for it (i.e. with a master playlist).
  let lastBitrate: number | undefined = undefined;
  let hasMessaged = false;
  player.on('timeupdate', () => {
    const vhs = tech.vhs || tech.hls;
    if (!vhs) {
      if (!hasMessaged) {
        log.info('No vhs unable to setup bitrate tracker');
        hasMessaged = true;
      }
      return;
    }
    const b = getBandwidth(vhs);
    if (!b) {
      return;
    }
    const e = NonStdPlayerEvents.playbackbitratechanged.code;
    if (b && b != lastBitrate) {
      log.debug('new timeupdate event', { b, e });
      dispatchPlayerEvent({ b, e });
    }
    lastBitrate = b;
  });
};
export default addHlsBitrateTracker;
